import { createContext, useContext } from 'react';

export type ContextType = {
  row: any;
};

//@ts-ignore
export const RowContext = createContext<ContextType>(null);

export const useRow = () => useContext(RowContext);
